"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.chainEventHandlers = chainEventHandlers;
/**
 * Chain event handlers.
 *
 *
 * @returns an event handler which calls all given handler by order while skipping undefined handlers.
 */
function chainEventHandlers() {
  for (var _len = arguments.length, handlers = Array(_len), _key = 0; _key < _len; _key++) {
    handlers[_key] = arguments[_key];
  }

  return function (event) {
    return handlers.filter(function (i) {
      return i;
    }).forEach(function (handler) {
      return handler(event);
    });
  };
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-style-react/dist/src/utils/ChainEventHandlers.js
// module id = 1390
// module chunks = 0